/**
 * @generated SignedSource<<cb413bd9940dee5b6ba8fe425d06ddcf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpsertStudentTargetGroupsForStudentInput = {
  studentTargetGroups: ReadonlyArray<BulkUpsertStudentTargetGroupsInput>;
};
export type BulkUpsertStudentTargetGroupsInput = {
  isActive: boolean;
  isCurrent: boolean;
  studentId: string;
  targetGroupId: string;
};
export type DiagnosticUpsertStudentTargetGroupsForStudentMutation$variables = {
  input: UpsertStudentTargetGroupsForStudentInput;
};
export type DiagnosticUpsertStudentTargetGroupsForStudentMutation$data = {
  readonly upsertStudentTargetGroupsForStudent: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
    }> | null | undefined;
    readonly studentTargetGroupNode: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly isCurrent: boolean;
      readonly targetGroup: {
        readonly id: string;
      } | null | undefined;
      readonly user: {
        readonly id: string;
      } | null | undefined;
    }> | null | undefined;
  };
};
export type DiagnosticUpsertStudentTargetGroupsForStudentMutation = {
  response: DiagnosticUpsertStudentTargetGroupsForStudentMutation$data;
  variables: DiagnosticUpsertStudentTargetGroupsForStudentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertStudentTargetGroupsForStudentPayload",
    "kind": "LinkedField",
    "name": "upsertStudentTargetGroupsForStudent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudentTargetGroupNode",
        "kind": "LinkedField",
        "name": "studentTargetGroupNode",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCurrent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticUpsertStudentTargetGroupsForStudentMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiagnosticUpsertStudentTargetGroupsForStudentMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2ec05a27ebdb4de494d782adbd4f22a4",
    "id": null,
    "metadata": {},
    "name": "DiagnosticUpsertStudentTargetGroupsForStudentMutation",
    "operationKind": "mutation",
    "text": "mutation DiagnosticUpsertStudentTargetGroupsForStudentMutation(\n  $input: UpsertStudentTargetGroupsForStudentInput!\n) {\n  upsertStudentTargetGroupsForStudent(input: $input) {\n    studentTargetGroupNode {\n      id\n      isActive\n      isCurrent\n      targetGroup {\n        id\n      }\n      user {\n        id\n      }\n    }\n    errors {\n      __typename\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f38961c694d8850b2defddc7a0b21de2";

export default node;
